import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTaxAndAccountingOnboardingResume } from './tax-and-accounting-onboarding.types';

type UseTaxAndAccountingOnboardingResumeResponse = {
  taxAndAccountingOnboardingResume: TTaxAndAccountingOnboardingResume;
};

/**
 * The corporation's single resumable (in-progress) onboarding draft, or `draft: null` when there is
 * none. Used to restore the wizard (step + all inputs) on open. Gated by the backend feature flag —
 * when off it errors and resolves to no draft (wizard starts fresh).
 */
function useTaxAndAccountingOnboardingResume(corporationId: number | null) {
  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data: UseTaxAndAccountingOnboardingResumeResponse | undefined;
    error: Error | undefined;
    mutate: KeyedMutator<UseTaxAndAccountingOnboardingResumeResponse>;
    isLoading: boolean;
  } = useSWR(
    corporationId
      ? `tax-and-accounting-onboarding/resume?corporationId=${corporationId}`
      : null,
    SWRFetcher({ method: 'GET' }),
    { shouldRetryOnError: false }
  );

  return {
    data: data?.taxAndAccountingOnboardingResume,
    error,
    mutate,
    isLoading: isLoading ?? false,
  };
}

export { useTaxAndAccountingOnboardingResume };
